import React from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import {  useFormContext } from "react-hook-form";
import marketing from "../../../services/marketing";

function PrequalAuthorizationConsent({disabledFields}) {
  
  const Setting = useStoreState((state) => state.siteSettingsModel);
  const info = useStoreState((state) => state.applicantModel.applicant);
  const setInfo = useStoreActions(actions => actions.applicantModel.setApplicant);
  const {  register, formState: { errors } } = useFormContext();

  const utms = new marketing();

  return (
    <>
      { /* Authorize Prequalification */}
      <div className="row">
          <div className="col-12">
              <div className="form-check check-fields">
                  <div className="input-container">
                      <input 
                          checked={info.authPrequal === "1" ? true : false} 
                          value={"1"} 
                          onClick={
                              (e) => {
                                  setInfo({ index: "authPrequal", value: info.authPrequal === "1" ? "0" : "1", });
                              }
                            } 
                            disabled={disabledFields} className="form-check-input" type="checkbox" id="authPrequal" {...register("authPrequal", {  shouldUnregister: true })} />
                      <label className="form-check-label" htmlFor="authPrequal">
                          I Authorize Pre-qualification. Checking to see if you pre-qualify for an offer won't impact your credit score, but if you receive an offer and accept it, that may impact your score.
                      </label>
                  </div>
                  { errors.authPrequal ? errors.authPrequal && <span className='error-message'> You need to agree before continue  </span> : '' }
              </div>
          </div>
          { /* Agreement */}
          <div className="col-12">
              <div className="form-check check-fields">
                  <div className="input-container">
                      <input 
                        checked={info.eSignConsent === "1" ? true : false}
                        value={"1"} 
                        onClick={(e) => { setInfo({ index: "eSignConsent", value: info.eSignConsent === "1" ? "0" : "1" }); setInfo({ index: "emailOptIn", value: !info.emailOptIn }); }}
                        disabled={disabledFields}
                        className="form-check-input"
                        type="checkbox"
                        id="optin-e-disclosure"
                        {...register("eSignConsent")} />
                      <input type="hidden" {...register("emailOptIn")} value={info.emailOptIn.toString()} />
                      <label className="form-check-label" htmlFor="optin-e-disclosure">
                          By clicking on this box you agree that you have read and consent to <a onClick={() => { utms.updateSessionReport("disclosureLink") }} rel="noopener noreferrer" href={Setting.productSettings.ESignUrl} target="_blank">Electronic Communications Disclosure</a> and the <a rel="noopener noreferrer" href={Setting.productSettings.PrivacyUrl} target="_blank">Privacy Notice</a>.
                      </label>
                  </div>
                  { errors.eSignConsent ? errors.eSignConsent && <span className='error-message'> You need to agree before continue  </span> : '' }
              </div>
          </div>
      </div>
    </>
  );
}
export default PrequalAuthorizationConsent;